import React from 'react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../components/ui/dialog';
import { Save, X } from 'lucide-react';

export default function ActivityBillingDialogs({
  showPlanDialog, setShowPlanDialog, showCreditDialog, setShowCreditDialog,
  editingPlan, planForm, setPlanForm, creditForm, setCreditForm,
  handleCreatePlan, handleUpdatePlan, handleCreateCredit,
  setEditingPlan, resetPlanForm, resetCreditForm
}) {
  return (
    <>
        <Dialog open={showPlanDialog} onOpenChange={setShowPlanDialog}>
          <DialogContent className="max-w-2xl">
            <DialogHeader>
              <DialogTitle>
                {editingPlan ? 'Modifier le Plan' : 'Créer un Plan'}
              </DialogTitle>
              <DialogDescription>
                Définissez les caractéristiques du plan
              </DialogDescription>
            </DialogHeader>
            
            <div className="space-y-4">
              <div>
                <Label>Nom du Plan</Label>
                <Input
                  value={planForm.name}
                  onChange={(e) => setPlanForm({...planForm, name: e.target.value})}
                  placeholder="Ex: Plan Essentiel"
                />
              </div>

              <div>
                <Label>Description</Label>
                <Input
                  value={planForm.description}
                  onChange={(e) => setPlanForm({...planForm, description: e.target.value})}
                  placeholder="Description du plan"
                />
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <Label>Prix (€)</Label>
                  <Input
                    type="number"
                    value={planForm.price}
                    onChange={(e) => setPlanForm({...planForm, price: e.target.value})}
                    placeholder="99.00"
                  />
                </div>

                <div>
                  <Label>Période</Label>
                  <select
                    value={planForm.billing_period}
                    onChange={(e) => setPlanForm({...planForm, billing_period: e.target.value})}
                    className="w-full px-3 py-2 border rounded-md"
                  >
                    <option value="monthly">Mensuel</option>
                    <option value="yearly">Annuel</option>
                    <option value="one_time">Paiement unique</option>
                  </select>
                </div>
              </div>

              <div className="flex items-center gap-2">
                <input
                  type="checkbox"
                  checked={planForm.is_popular}
                  onChange={(e) => setPlanForm({...planForm, is_popular: e.target.checked})}
                  className="rounded"
                />
                <Label>Plan populaire (recommandé)</Label>
              </div>

              <div className="flex gap-2">
                <Button
                  onClick={editingPlan ? handleUpdatePlan : handleCreatePlan}
                  className="bg-blue-600 hover:bg-blue-700"
                >
                  <Save className="h-4 w-4 mr-2" />
                  {editingPlan ? 'Mettre à jour' : 'Créer'}
                </Button>
                <Button
                  onClick={() => {
                    setShowPlanDialog(false);
                    setEditingPlan(null);
                    resetPlanForm();
                  }}
                  variant="outline"
                >
                  <X className="h-4 w-4 mr-2" />
                  Annuler
                </Button>
              </div>
            </div>
          </DialogContent>
        </Dialog>

        {/* Dialog Création Package Crédits */}
        <Dialog open={showCreditDialog} onOpenChange={setShowCreditDialog}>
          <DialogContent className="max-w-2xl">
            <DialogHeader>
              <DialogTitle>Créer un Package de Crédits</DialogTitle>
              <DialogDescription>
                Définissez le package de crédits
              </DialogDescription>
            </DialogHeader>
            
            <div className="space-y-4">
              <div>
                <Label>Nom du Package</Label>
                <Input
                  value={creditForm.name}
                  onChange={(e) => setCreditForm({...creditForm, name: e.target.value})}
                  placeholder="Ex: Pack 100 crédits"
                />
              </div>

              <div>
                <Label>Description</Label>
                <Input
                  value={creditForm.description}
                  onChange={(e) => setCreditForm({...creditForm, description: e.target.value})}
                  placeholder="Description du package"
                />
              </div>

              <div className="grid grid-cols-3 gap-4">
                <div>
                  <Label>Nombre de Crédits</Label>
                  <Input
                    type="number"
                    value={creditForm.credits}
                    onChange={(e) => setCreditForm({...creditForm, credits: e.target.value})}
                    placeholder="100"
                  />
                </div>

                <div>
                  <Label>Prix (€)</Label>
                  <Input
                    type="number"
                    value={creditForm.price}
                    onChange={(e) => setCreditForm({...creditForm, price: e.target.value})}
                    placeholder="75.00"
                  />
                </div>

                <div>
                  <Label>Valeur/Crédit (€)</Label>
                  <Input
                    type="number"
                    value={creditForm.credit_value}
                    onChange={(e) => setCreditForm({...creditForm, credit_value: e.target.value})}
                    placeholder="1.00"
                  />
                </div>
              </div>

              <div className="flex gap-2">
                <Button
                  onClick={handleCreateCredit}
                  className="bg-green-600 hover:bg-green-700"
                >
                  <Save className="h-4 w-4 mr-2" />
                  Créer
                </Button>
                <Button
                  onClick={() => {
                    setShowCreditDialog(false);
                    resetCreditForm();
                  }}
                  variant="outline"
                >
                  <X className="h-4 w-4 mr-2" />
                  Annuler
                </Button>
              </div>
            </div>
          </DialogContent>
        </Dialog>
    </>
  );
}
